// Acordeón exclusivo — compatible con <details> nativo y componentes del tema
(function () {
  function closeOthers(opened, parent) {
    // Para <details> nativos
    parent.querySelectorAll('details[open]').forEach(function (d) {
      if (d !== opened) d.removeAttribute('open');
    });
    // Para componentes con clase active/expanded del tema
    parent.querySelectorAll('.is-open, .collapsible--active').forEach(function (el) {
      if (el !== opened) {
        el.classList.remove('is-open', 'collapsible--active');
        var inner = el.querySelector('.collapsible__content, .tab__content');
        if (inner) inner.style.maxHeight = '0';
      }
    });
  }

  function initAccordion() {
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('summary');
      if (summary) {
        var details = summary.closest('details');
        if (details) {
          // Pequeño delay para dejar que el browser procese el open
          setTimeout(function () {
            closeOthers(details, details.parentNode);
          }, 10);
        }
        return;
      }

      // Soporte para botones tipo tab del tema
      var btn = e.target.closest('[data-accordion-trigger], .tab__trigger, .collapsible-trigger');
      if (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls') || btn.dataset.target);
        if (panel) {
          setTimeout(function () {
            closeOthers(panel, panel.parentNode);
          }, 10);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
})();
